import { useState } from "react";
import { buttonLabels, generateCardData } from "../../utils/data";
import { useOutletContext } from "react-router-dom";
import useAgentData from "../../utils/hooks/useAgentData";
import ActiveChats from "./ActiveChats";
import RecentEmails from "./RecentEmails";
import SocialMediaMentions from "./SocialMediaMentions";
import { Loader, SummaryCardGrid, TabButtonGroup } from "../shared";

const Dashboard = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { dashboardSummary, loading } = useAgentData();
  const { toggleSidebar, toggleInfo } = useOutletContext();

  if (loading) {
    return (
      <div className="w-full h-[calc(100vh-100px)] flex items-center justify-center">
        <Loader size={40} color="black" />
      </div>
    );
  }
  if (!dashboardSummary) return <div>No dashboard data available.</div>;

  const cardData = generateCardData(dashboardSummary);

  return (
    <div className="flex flex-col w-full  min-h-[calc(100vh-100px)] gap-y-6 md:gap-y-0 lg:gap-3 ">
      <div className="w-full h-auto border-b border-[#0000002B] flex justify-between items-center   pb-2 ">
        <span className="text-[13px] font-semibold leading-[100%] text-black font-inter">
          Dashboard
        </span>

        {/* This will show only on small screens */}
        <div className="flex flex-row items-center gap-2 md:hidden">
          <button
            onClick={toggleSidebar}
            className="px-3 py-1 text-[10px] font-medium text-black border border-[#0000002B] rounded-md hover:bg-black-700 transition"
          >
            Menu
          </button>
          <button
            onClick={toggleInfo}
            className="px-3 py-1 text-[10px] font-medium text-black border border-[#0000002B] rounded-md hover:bg-black-700 transition"
          >
            Info
          </button>
        </div>
      </div>

      <TabButtonGroup
        buttonLabels={buttonLabels}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />

      <SummaryCardGrid data={cardData} />

      <div className="flex flex-col w-full pr-2 lg:flex-1 md:flex-row gap-x-4 gap-y-6 md:gap-y-0">
        <ActiveChats />
        <RecentEmails />
      </div>
      <div className="pr-2 ">
        <SocialMediaMentions />
      </div>
    </div>
  );
};

export default Dashboard;
